/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsHoopPlatform
 */
export interface AssetsMelcoModelsHoopPlatform {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopPlatform
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoopPlatform
     */
    sf_area?: number;
}

export function AssetsMelcoModelsHoopPlatformFromJSON(json: any): AssetsMelcoModelsHoopPlatform {
    return AssetsMelcoModelsHoopPlatformFromJSONTyped(json, false);
}

export function AssetsMelcoModelsHoopPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsHoopPlatform {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'sf_area': !exists(json, 'sf_area') ? undefined : json['sf_area'],
    };
}

export function AssetsMelcoModelsHoopPlatformToJSON(value?: AssetsMelcoModelsHoopPlatform | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sf_area': value.sf_area,
    };
}


